import {BomItemApiDto, BomItemsApiDto, CreateUpdateBillOfMaterialsPreviewAssetApiDto} from "../../api/model/rest";
import {BillOfMaterialsPreviewItemOfMaterial} from "./BillOfMaterialsPreviewItems";
import {none, option, Option} from "ts-option";
import Price from "../common/Price";
import JsonConverter from "../../api/helper/JsonConverter";

export class BomItems {
	constructor(
		public readonly assets: BomItem[]) {}

	static fromJson(json: BomItemsApiDto): BomItems {
		return new BomItems(json.assets.map(BomItem.fromJson).sort((a, b) => Number(a.selfSourced) - Number(b.selfSourced)))
	}
}

export class BomItem {
	constructor(
		public readonly id: string,
		public readonly buy: Option<Price>,
		public readonly manufacturerName: Option<string>,
		public readonly markup: number,
		public readonly margin: Price,
		public readonly materials: BillOfMaterialsPreviewItemOfMaterial[],
		public readonly name: string,
		public readonly profit: Option<Price>,
		public readonly profitInPercentage: Option<number>,
		public readonly quantity: number,
		public readonly rebate: Price,
		public readonly sell: Price,
		public readonly rebateUnitPrice: Price,
		public readonly sellUnitPrice: Price,
		public readonly selfSourced: boolean
	) {}

	static fromJson(json: BomItemApiDto): BomItem {
		const manufacturerName = option(json.manufacturerName);
		const buy = json.buy ? option(Price.fromJson(json.buy)) : none;
		const profit = json.profit ? option(Price.fromJson(json.profit)) : none;
		const profitInPercentage = option(json.profitInPercentage);
		return new BomItem(json.id, buy, manufacturerName, json.markup,
			Price.fromJson(json.margin), json.materials.map(BillOfMaterialsPreviewItemOfMaterial.fromJson),
			json.name, profit, profitInPercentage, json.quantity, Price.fromJson(json.rebate), Price.fromJson(json.sell),
			Price.fromJson(json.rebateUnitPrice), Price.fromJson(json.sellUnitPrice), json.selfSourced);
	}

	toJson(): CreateUpdateBillOfMaterialsPreviewAssetApiDto {
		const json: CreateUpdateBillOfMaterialsPreviewAssetApiDto = {
			name: this.name,
			manufacturerName: this.manufacturerName.orNull,
			sellUnitPrice: this.sellUnitPrice,
			markup: this.markup,
			quantity: this.quantity,
			rebateUnitPrice: this.rebateUnitPrice,
			selfSourced: this.selfSourced
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({
		id = this.id,
		buy = this.buy,
		manufacturerName = this.manufacturerName,
		markup = this.markup,
		margin = this.margin,
		materials = this.materials,
		name = this.name,
		profit = this.profit,
		profitInPercentage = this.profitInPercentage,
		quantity = this.quantity,
		rebate = this.rebate,
		sell = this.sell,
		rebateUnitPrice = this.rebateUnitPrice,
		sellUnitPrice = this.sellUnitPrice,
		selfSourced = this.selfSourced
	}) {
		return new BomItem(id, buy, manufacturerName, markup, margin, materials,
			name, profit, profitInPercentage, quantity, rebate, sell, rebateUnitPrice, sellUnitPrice, selfSourced);
	}
}